<template>
  <div class="moderations">
    <template v-if="tableItems.length">
      <p class="h3">Список площадок</p>

      <div class="moderations__panel">
        <BaseInput
          v-model="searchValue"
          placeholder="Поиск по всем параметрам"
          isSearch
          class="moderations__input"
          @enter="onSearch"
        />
      </div>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        class="moderations__table"
        @sort="onSortTable"
      >
        <template #title="{ id, title }">
          <BaseLink :href="`/moderations/${id}`">
            {{ title }}
          </BaseLink>
        </template>

        <template #createdBy="{ createdBy }">
          <BaseLink :href="`/user/${createdBy.id}`">
            {{ createdBy.name ?? '' }} {{ createdBy.surname ?? '' }}
          </BaseLink>
        </template>
      </AppTable>

      <div
        v-if="(paginationTotal / paginationPerPage) > 1"
        class="moderations__pag-wrapper"
      >
        <AppPagination
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>

    <p v-else class="h3">Список модераций пуст.</p>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import AppTable from '@/components/AppTable'
import AppPagination from '@/components/Base/AppPagination'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'ModerationsPage',
  components: {
    BaseInput,
    AppTable,
    AppPagination,
    BaseLink
  },
  data () {
    return {
      tableFields: [
        { key: 'title', label: 'Название', sortable: true, slot: true },
        { key: 'address', label: 'Адрес', sortable: true },
        { key: 'createdBy', label: 'Создатель', sortable: true, slot: true },
        { key: 'createdAt', label: 'Время создания', sortable: true }
      ],
      tableItems: [],
      searchValue: '',
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    requestBody () {
      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        searchBy: this.searchValue,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /**
     * Отслеживанию изменение св-ва и подтягиваю новые данные таблицы
     */
    paginationCurrent: 'fetchModerations'
  },
  async created () {
    await this.fetchModerations()
  },
  methods: {
    async fetchModerations () {
      const { data } = await this.$api.moderation.list(this.requestBody)
      const moderations = data?.list ?? []

      /* Записал общее колво пользователей */
      this.paginationTotal = data.pages * this.paginationPerPage

      this.tableItems = moderations.map(item => {
        const address = item?.address ?? ''
        const createdAt = item?.createdAt ?? ''
        const title = item?.title ?? ''
        const createdBy = item?.createdBy ?? {}

        return {
          id: item?.id,
          address,
          createdAt,
          title,
          createdBy
        }
      })
    },
    /**
     * Записал новое значение поиска
     */
    onSearch () {
      this.fetchModerations()
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchModerations()
    }
  }
}
</script>

<style lang="scss" scoped>
.moderations {
  &__input {
    max-width: 640px;
    margin-top: 20px;
  }

  &__table {
    margin-top: 20px;
  }

  &__pag-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
